import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import { Grid, IconButton, Typography, Button, Input, Tooltip } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { HOST_API_URL } from '../../../../config-global';
import Iconify from '../../../../reusable-components/iconify';

CensusTableToolbar.propTypes = {
  saving: PropTypes.bool,
  censusData: PropTypes.object,
  save: PropTypes.func,
  facilityId: PropTypes.number,
};

export default function CensusTableToolbar({ censusData, save, saving, facilityId })
{
  const [editCensusDays, setEditCensusDays] = useState(false);
  const [newBudgetDayCount, setNewBudgetDayCount] = useState(censusData?.budgetDayCount);

  return <Grid container direction="row" justifyContent="flex-start" alignItems="flex-end"
    spacing={2}>
    {editCensusDays ? <>
      <Grid item>
        <Typography variant="subtitle1">
          Census days included
        </Typography>
        <Input
          size="small"
          defaultValue={censusData?.budgetDayCount ?? 0}
          autoFocus
          onChange={(e) => {
            const val = e.target.value ? Number(e.target.value?.replace(/\D/g, "")) : null;
            e.target.value = val > 30 ? 30 : val;
            setNewBudgetDayCount(e.target.value);
          }}
          sx={{ width: 150 }}
        />
      </Grid>
      <Grid item>
        <Button variant="outlined" color="error" size="small" sx={{ width: 150, mr: 2 }}
          onClick={() => { setEditCensusDays(false); setNewBudgetDayCount(censusData?.budgetDayCount); }}>
          Cancel
        </Button>
        <LoadingButton loading={saving} variant="contained" color="primary" size="small" sx={{ width: 150 }}
          onClick={() => save(newBudgetDayCount ?? 0)}>
          Save
        </LoadingButton>
      </Grid>
    </> : <>
      <Grid item>
        <Typography variant="subtitle1">
          Census days included
        </Typography>
        <Typography variant="subtitle1" sx={{ color: 'primary.main' }}>
          {censusData?.budgetDayCount}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="subtitle1">
          Today's Census
        </Typography>
        <Typography variant="subtitle1" sx={{ color: 'primary.main' }}>
          {censusData?.current}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="subtitle1">
          Census Total
        </Typography>
        <Typography variant="subtitle1" sx={{ color: 'primary.main' }}>
          {censusData?.censusTotal}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="subtitle1">
          {censusData?.budgetDayCount} Day Avg
        </Typography>
        <Typography variant="subtitle1" sx={{ color: 'primary.main' }}>
          {censusData?.average}
        </Typography>
      </Grid>
      <Grid item>
        <Tooltip arrow title="Update census days included">
          <IconButton edge="end" color="secondary"
            onClick={() => { setEditCensusDays(true); setNewBudgetDayCount(censusData?.budgetDayCount); }} >
            <EditIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    </>}
    <Grid item>
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        disabled={!facilityId}
        onClick={() => window.open(`${HOST_API_URL}Api/Admin/FacilityCensus/DownloadCensusData?facilityId=${facilityId}`, '_blank')}
        startIcon={<Iconify icon="file-icons:microsoft-excel" />}
      >
        Download
      </Button>
    </Grid>
  </Grid>;
}
